import { create } from 'zustand';
import api, { isServerConfigured, clearAuthToken } from '../api/axios';

export const ROLE_HOME = {
  admin:            '/home',
  ict_manager:      '/home',
  jr_engineer:      '/home',
  sr_engineer:      '/home',
  employee_manager: '/home',
  employee:         '/home',
  dashboard_viewer: '/home',
};

export const MANAGER_ROLES  = ['admin', 'ict_manager', 'employee_manager', 'project_manager', 'delivery_manager'];
export const OPERATOR_ROLES = ['admin', 'ict_manager', 'jr_engineer', 'sr_engineer'];

export const useAuthStore = create((set, get) => ({
  user:    null,
  loading: true,

  // Called once on app mount — checks if a valid session cookie exists
  init: async () => {
    // On mobile, skip auth check if no server URL is configured yet
    if (!isServerConfigured() && !process.env.REACT_APP_API_URL && window.location.protocol !== 'http:' && window.location.protocol !== 'https:') {
      set({ user: null, loading: false });
      return;
    }
    try {
      const { data } = await api.get('/auth/me');
      set({ user: data, loading: false });
    } catch {
      // No valid session — user needs to log in
      set({ user: null, loading: false });
    }
  },

  login: async (email, password) => {
    // Server sets httpOnly cookie for web + returns token for mobile
    const { data } = await api.post('/auth/login', { email, password });
    if (data.token) {
      const { setAuthToken } = require('../api/axios');
      setAuthToken(data.token);
    }
    set({ user: data.user });
    return data.user;
  },

  logout: async () => {
    try {
      await api.post('/auth/logout'); // clears the httpOnly cookie server-side
    } catch { /* ignore network errors on logout */ }
    clearAuthToken(); // clear stored token (mobile)
    set({ user: null });
  },

  refreshUser: async () => {
    try {
      const { data } = await api.get('/auth/me');
      set({ user: data });
      return data;
    } catch { /* silent */ }
  },

  hasRole: (...roles) => {
    const flat = roles.flat();
    return flat.includes(get().user?.role);
  },

  // True if the current user's effective permission set includes any of the
  // given permissions. Admin implicitly passes (full access).
  hasPermission: (...perms) => {
    const user = get().user;
    if (!user) return false;
    if (user.role === 'admin') return true;
    const flat = perms.flat();
    const granted = Array.isArray(user.permissions) ? user.permissions : [];
    return flat.some(p => granted.includes(p));
  },

  get homeRoute() {
    return ROLE_HOME[get().user?.role] || '/tickets';
  },
}));
